/** @file screenToTexel: the tile texel under a screen point of a placed part, or null outside its quad. */
import type { PlacedPart, Point } from './sheetTypes';

/**
 * Inverts the quad's affine frame (tl, tl->tr = the tile's width, tl->bl = its height) at (`x`, `y`) and returns the
 * texel `[tx, ty]` of the unflipped tile (a flipped part reads its texels mirrored), or null outside the tile.
 */
export function screenToTexel(part: Pick<PlacedPart, 'quad' | 'size' | 'flip'>, x: number, y: number): Point | null {
  const [tl, tr, , bl] = part.quad;
  const [w, h] = part.size;
  const ax = tr[0] - tl[0]; const ay = tr[1] - tl[1];
  const bx = bl[0] - tl[0]; const by = bl[1] - tl[1];
  const det = ax * by - ay * bx;
  if (Math.abs(det) < 1e-9) return null;
  const dx = x - tl[0]; const dy = y - tl[1];
  const u = ((dx * by - dy * bx) / det) * w;
  const v = ((ax * dy - ay * dx) / det) * h;
  if (u < 0 || v < 0 || u >= w || v >= h) return null;
  const tx = Math.floor(u);
  return [part.flip ? w - 1 - tx : tx, Math.floor(v)];
}
